module.exports = __webpack_public_path__ + "img/dots_mtp3.54090c11.png";